module.exports = __webpack_public_path__ + "static/img/times-svgrepo-com.ea0b733b.svg";